export default __webpack_public_path__ + "static/media/americanAssociation.c79a5cf8.JPG";